import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Button, Chip, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Add, CheckCircle, ClearAllRounded, ClearOutlined, ClearRounded } from "@mui/icons-material";
import axios from "axios";
import toast from "react-hot-toast";
import { useApiClient } from "../../context/ApiClientContext";
import Listing from "./listing";
import { valueTagsList } from "../../data/valueTagData";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ComponentBackdrop from "../../components/backdrop";
import ConfirmDialog from "../../helper/confirmDialog";

export const DataContext = React.createContext();

const Index = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showButton, setShowButton] = useState(false);
  const [selectedRows, setRows] = useState([]);
  const [filteredDataList, setFilteredDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const location = useLocation();
  const navigate = useNavigate();
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState('create');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  

  const handleOpenConfirm = () => {
    console.log('select', selectedIds);
    
    if (selectedIds.length === 0) {
      toast.warning("Please select at least one value tag to delete.");
      return;
    }
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => setOpenConfirm(false);


  const handleShowButton = (ids) => {
    setSelectedIds(ids);
    setShowButton(ids.length > 0);
  };

  useEffect(() => {
    fetchDataAndUpdateList();
  }, [location.pathname]);

  const fetchDataAndUpdateList = async () => {
    try {

      const apiUrl = `${mobileApiUrl}valueTag/view-list`;
      const response = await api.get(apiUrl);


      let valueTagList = [];
      if (Array.isArray(response.data.data)) {
        valueTagList = response.data.data;
      } else if (Array.isArray(response.data.valueTagList)) {
        valueTagList = response.data.valueTagList;
      }

      const dataWithKeys = valueTagList.map((item) => ({
        ...item,
        id: item.valueTagHeaderId,
      }));
      console.log('dataWithKeys', dataWithKeys);
      
      setFilteredDataList(dataWithKeys);
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

  const handleConfirmDelete = async () => {
    setOpenBackdrop(true);
    try {
      const apiUrl = `${mobileApiUrl}valueTag/delete`;
      const response = await api.delete(apiUrl,  {
        data: { valueTagHeaderIds: selectedIds },
      });

      if (response.status === 200) {
        const deletedItems = filteredDataList.filter(item =>
          selectedIds.includes(item.id)
        );
        const deletedNames = deletedItems.map(item => item.code);

        toast.success(`Deleted: ${deletedNames.join(", ")}`);

        setFilteredDataList(prev =>
          prev.filter(item => !selectedIds.includes(item.id))
        );
        setSelectedIds([]);
        setOpenBackdrop(false);
        setOpenConfirm(false);
      } else {
        toast.error("Failed to delete departments. Please try again.");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      ErrorAlert(error, navigate);
    } finally {
        setOpenBackdrop(false);
    }
  };



  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <ComponentBackdrop openBackdrop={openBackdrop} />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BasicBreadcrumbs first="Value Tag System" />

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{
              width: { xs: "100%", sm: "auto" },
              alignItems: { xs: "stretch", sm: "flex-start" },
            }}
          >

           
              
            {showButton && (
              <>
                <Button
                  variant="contained"
                  size="medium"
                  fullWidth={isMobile}
                  sx={{
                    backgroundColor: "secondary.main",
                    fontWeight: "600",
                    "&:hover": { backgroundColor: "secondary.dark" },
                    whiteSpace: "nowrap",
                  }}
                  onClick={handleOpenConfirm}
                >
                  Delete
                </Button>
              </>
            )}

             <ConfirmDialog
                open={openConfirm}
                onClose={handleCloseConfirm}
                onConfirm={handleConfirmDelete}
                title="Delete Value Tag"
                message={`Are you sure you want to delete ${selectedIds.length > 1 ? "these value tags" : "this value tag"
                  }?`}
                items={filteredDataList
                  .filter(item => selectedIds.includes(item.id))
                  .map(item => item.code)}
                confirmText="Delete"
                confirmColor="error"
              />


            <Link to="/create-valuetag" style={{ textDecoration: "none" }}>
              <Button
                display="none"
                variant="contained"
                size="medium"
                startIcon={<Add />}
                fullWidth={isMobile}
                sx={{
                  backgroundColor: "secondary.main",
                  fontWeight: "600",
                  "&:hover": { backgroundColor: "secondary.dark" },
                  whiteSpace: "nowrap",
                  hidden: "true",
                }}
              >
                Add Value Tag
              </Button>
            </Link>

            {/* <ImportButton fullWidth={isMobile} /> */}
          </Stack>
        </Box>
        <DataContext.Provider value={filteredDataList}>
          <Listing
            currentPage={currentPage}
            totalPage={totalPage}
            pageSize={pageSize}
            handleShowButton={handleShowButton}
          />
        </DataContext.Provider>
      </Box>
    </PrivateLayout>
  );
};

export default Index;